import axios, { AxiosResponse } from "axios";

export interface Author {
  fb: string;
  google_plus: string;
  name: string;
  twitter: string;
  url: string;
  img: string;
  OID: number;
  about?: string;
}

export async function getAuthors(): Promise<Author[]> {
  try {
    const res: AxiosResponse<Author[]> = await axios.post(
      `${window.API_HOST}/api/authors/list`
    );
    return res.data;
  } catch (err) {
    if (axios.isAxiosError(err)) {
      throw { status: err.response!.status, errors: err.response!.data.errors };
    } else {
      throw new Error("Cannot request info.");
    }
  }
}
